import React, { useState, useEffect, Fragment } from "react";
import parse from "html-react-parser";
import { useParams } from "react-router-dom";
import styles from "./styles.module.sass";
import Page from "../../layouts/Page";
import TextBlock from "../../components/TextBlock";
import { hostname } from "../../constants";

interface FeaturedMedia {
  media_details: {
    sizes: {
      large: { source_url: string };
    };
  };
}

// interface LocalPageData {
//   content: { rendered: string };
//   _embedded: {
//     "wp:featuredmedia": FeaturedMedia[];
//   };
//   acf:
// }

const LocalHome: React.FC = () => {
  const params = useParams<Record<string, string>>();
  const country = params.country || "";
  const [data, setData] = useState<any | null>(null);
  const [countryImg, setCountryImg] = useState<string>("");
  const [loading, setLoading] = useState(true);

  // console.log(data);
  // console.log(country)

  useEffect(() => {
    setLoading(true);
    fetch(`${hostname}/${country}/wp-json/wp/v2/pages/7?_embed`)
      .then((res) => res.json())
      .then((json: any) => {
        setData(json);
      })
      .catch(() => {
        console.error;
      })
      .finally(() => setLoading(false));
  }, [country]);

  if (!data) return null;

  return (
    <Page type="local" className={styles.base} country={country}>
      {!loading && (
        <Fragment>
          <img
            src={
              data._embedded["wp:featuredmedia"][0].media_details.sizes.large
                .source_url
            }
            alt=""
          />
          <div className={styles.intro}>
            <TextBlock>{parse(data.content.rendered)}</TextBlock>
          </div>
          <img src={data.acf[`homepageImg_${country}`]} alt="" style={{ marginTop: 10 }} />
        </Fragment>
      )}
    </Page>
  );
};

export default LocalHome;
